/* eslint-disable camelcase */
/**
 *  Do not edit this file! It is autogenerated from the harmony composerasdfsad
 */
import {
  withLayout,
  withLayoutAccordion,

} from '@thd-olt-component-react/fusion-utils';

import { BrowseSearchMetadata }
from '@thd-olt-component-react/metadata';

import { TrackOrder }
from '@thd-olt-component-react/track-order';

import { Breadcrumbs }
from '@thd-olt-component-react/breadcrumbs';

import { SponsoredBannerComposable }
from '@thd-olt-component-react/sponsored-content';

import {
  PLPResultsHeader, ResultsAppliedComposable, ResultsFilterAndSortDrawerComposable, ResultsDimensionsComposable, ResultsSortByComposable, ResultsPaginationComposable
}
from '@thd-olt-component-react/product-results';

import { HybridContentfulWidgetComposable }
from '@thd-olt-component-react/hybrid';

import { ProductCategoryVisnavComposable }
from '@thd-olt-component-react/product-category-visnav';

import { PLPRecsComposable, PlpRvRenderPlaceholder }
from '@thd-olt-component-react/thd-recs-containers';

import { FlooringDrawer }
from '@thd-olt-component-react/flooring-picker';

import { DefaultGridComposable }
from '@thd-olt-component-react/plp-grid';

import { SearchFeedback }
from '@thd-olt-component-react/search-feedback';

import { RetailMediaCarouselFusionComposable }
from '@thd-olt-component-react/retail-media-pla-sponsored-placements';

import { EmtQuestionsAndAnswers, EmtGeneratedContent, BrandCategories }
from '@thd-olt-component-react/emt-generated-content';

import { RelatedSearch, RelatedProducts }
from '@thd-olt-component-react/related-search';

import { EmtLinks }
from '@thd-olt-component-react/emt-links';

import { BrowseSearchRedirector }
from '@thd-nucleus/app-render';

import { TempDatasourcesHackForFusionDataModels }
from '@thd-olt-component-react/temp-datasources-hack-for-fusion-dataModels';

export { BrowseSearchMetadata };

export { TrackOrder };

export { Breadcrumbs };

export { SponsoredBannerComposable };

export { PLPResultsHeader };

export { HybridContentfulWidgetComposable };

export { ProductCategoryVisnavComposable };

export { PLPRecsComposable };

export { ResultsAppliedComposable };

export { ResultsFilterAndSortDrawerComposable };

export { ResultsDimensionsComposable };

export { ResultsSortByComposable };

export { FlooringDrawer };

export { DefaultGridComposable };

export { ResultsPaginationComposable };

export { SearchFeedback };

export { RetailMediaCarouselFusionComposable };

export { PlpRvRenderPlaceholder };

export { EmtQuestionsAndAnswers };

export { EmtGeneratedContent };

export { BrandCategories };

export { RelatedSearch };

export { RelatedProducts };

export { EmtLinks };

export { BrowseSearchRedirector };

export { TempDatasourcesHackForFusionDataModels };

const SlotA1 = withLayout(
  [

    BrowseSearchMetadata,

  ],

);

const SlotA2 = withLayout(
  [

    TrackOrder,

  ],

);

const SlotA3 = withLayout(
  [

    Breadcrumbs,

  ],

);

const SlotB1 = withLayout(
  [

    SponsoredBannerComposable,

  ],

);

const SlotB2 = withLayout(
  [

    PLPResultsHeader,

  ],

);

const SlotB3 = withLayout(
  [

    HybridContentfulWidgetComposable,

  ],

);

const SlotB4 = withLayout(
  [

    ProductCategoryVisnavComposable,

  ],

);

const SlotC1 = withLayout(
  [

    PLPRecsComposable,

  ],

);

const SlotD1 = withLayout(
  [

    ResultsAppliedComposable,

  ],

);

const SlotD2 = withLayout(
  [

    ResultsFilterAndSortDrawerComposable,

  ],

);

const SlotE1 = withLayout(
  [

    ResultsDimensionsComposable,

  ],

);

const SlotF1 = withLayout(
  [

    ResultsSortByComposable,

  ],

);

const SlotG1 = withLayout(
  [

    FlooringDrawer,

  ],

);

const SlotH1 = withLayout(
  [

    DefaultGridComposable,

  ],

);

const SlotH2 = withLayout(
  [

    ResultsPaginationComposable,

  ],

);

const SlotH3 = withLayout(
  [

    SearchFeedback,

  ],

);

const SlotI1 = withLayout(
  [

    PLPRecsComposable,

  ],

);

const SlotI2 = withLayout(
  [

    RetailMediaCarouselFusionComposable,

  ],

);

const SlotI3 = withLayout(
  [

    PlpRvRenderPlaceholder,

  ],

);

const SlotJ1 = withLayout(
  [

    EmtQuestionsAndAnswers,

  ],

);

const SlotJ2 = withLayout(
  [

    EmtGeneratedContent,

  ],

);

const SlotJ3 = withLayout(
  [

    EmtGeneratedContent,

  ],

);

const SlotJ4 = withLayout(
  [

    BrandCategories,

  ],

);

const SlotK1 = withLayout(
  [

    RelatedSearch,

  ],

);

const SlotK2 = withLayout(
  [

    RelatedProducts,

  ],

);

const SlotL1 = withLayout(
  [

    EmtLinks,

  ],

);

const SlotL2 = withLayout(
  [

    BrowseSearchRedirector,

  ],

);

const SlotL3 = withLayout(
  [

    TempDatasourcesHackForFusionDataModels,

  ],

);

const ssr = typeof window === 'undefined';

export {

  SlotA1,

  SlotA2,

  SlotA3,

  SlotB1,

  SlotB2,

  SlotB3,

  SlotB4,

  SlotC1,

  SlotD1,

  SlotD2,

  SlotE1,

  SlotF1,

  SlotG1,

  SlotH1,

  SlotH2,

  SlotH3,

  SlotI1,

  SlotI2,

  SlotI3,

  SlotJ1,

  SlotJ2,

  SlotJ3,

  SlotJ4,

  SlotK1,

  SlotK2,

  SlotL1,

  SlotL2,

  SlotL3,

};
